<div *ngIf="uploadedFiles && uploadedFiles.length > 0"
     class="d-flex justify-content-between align-items-center col-md-12 overflow-auto"
     style="flex-direction: column; padding: 20px 0;">
      @for (category of categorizedFormGroupKeys | keyvalue; track category.key) {
        <div style="display: flex; flex-direction: column; align-items: start; padding: 10px; width: 100%;">
          <span class="d-flex justify-content-start align-items-center"
                style="margin-bottom: 1rem; width: 100%;">
            <i-tabler name="{{getOptionTypeIcon(category.key)}}"
                      style="color: var(--mat-sys-primary); margin-right: 1rem;"></i-tabler>
            <span
              class="text-uppercase font-weight-bold">{{ `${category.key} ${'UserDecisions.Options' | localize}` }}</span>
          </span>
          @for (control of category.value; track control.key) {
<!--                    TODO : Yetki koduna göre kullanıcının açabilmesi gerekiyor. Yetki kontrolü eklenmeli.-->
            <div [id]="$index" style="display: flex; flex-direction: row; justify-content: space-between; width: 100%;">
              <span style="padding-bottom: 16px;">
                {{ `${'UserDecisions.' + control.key | localize}` }}
              </span>
              <mat-slide-toggle [checked]="getControlValue(control.control)" (change)="changeOptions($event, control.key, control.sheetIndex)"></mat-slide-toggle>
            </div>
          }
        </div>
      }
</div>
